'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = splitBoxProps;

var _enhancers = require('../enhancers');

var _splitProps = require('./split-props');

var _splitProps2 = _interopRequireDefault(_splitProps);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Convenience method to split the Box props.
 *
 * Useful for when you want to pass all of the Box props to the root Box and
 * pass the remaining props to a child element (e.g: disabled, readOnly, required, etc).
 */


function splitBoxProps(props) {
  return (0, _splitProps2.default)(props, _enhancers.propNames);
}